import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Fabricstatus = ({ openLoginDialog, setOpenLoginDialog, selectedsubOrder, setgetSubOrder }) => {
    //handle close
    const handleClose = () => {
        setOpenLoginDialog(false);
        //empty the fields
        SetFabricStatus('')
    };


    const [fabricStatus, SetFabricStatus] = useState('');

    //handle change fabric order status
    const handleOrderStatus = async (selectedsubOrder) => {
        if (!fabricStatus) {
            toast.error("Please select a fabric status.");
            return;
        }

        try {
            const response = await instance.patch('/Order/changeFabricStatus',
                {
                    order_id: selectedsubOrder._id, // Use `selectedOrder` to access `order_id`
                    status: fabricStatus
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetSubOrder(true);

            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }
    return (
        <>
            <React.Fragment>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={openLoginDialog}
                    className="admin-admins"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Edit Fabric status
                        <Typography>Edit your suborder fabric status</Typography>
                    </DialogTitle>
                    <hr style={{ margin: "10px 0px" }} />
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <section className="add-admin">
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Select Fabric Status</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Select Fabric Status"
                                                required
                                                placeholder="Select Fabric Status"
                                                fullWidth
                                                value={fabricStatus}
                                                onChange={(e) => SetFabricStatus(e.target.value)}
                                            >
                                                <MenuItem value="Pending">Pending</MenuItem>
                                                <MenuItem value="Acquired">Acquired</MenuItem>
                                                {/* <MenuItem value="In Transit">In Transit</MenuItem>
                                                <MenuItem value="Completed">Completed</MenuItem>
                                                <MenuItem value="Delivered">Delivered</MenuItem>
                                                <MenuItem value="Canceled">Canceled</MenuItem> */}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </section>
                    </DialogContent>
                    <DialogActions>
                        <Button className="cancel-btn" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button className="add-btn" onClick={() => handleOrderStatus(selectedsubOrder)}>Change Status</Button>
                    </DialogActions>
                </BootstrapDialog>
            </React.Fragment>
        </>
    )
}

export default Fabricstatus